import { useState, useMemo, useEffect } from "react";
import { FixedSizeList as List } from "react-window";

export default function VirtualizedQuestionPicker({
  questions,
  selected,
  setSelected,
  onClose
}) {

  const [tempSelected,setTempSelected] = useState([]);

  const [search,setSearch] = useState("");
  const [topic,setTopic] = useState("");
  const [section,setSection] = useState("");
  const [difficulty,setDifficulty] = useState("");



  // initialize temporary selection
  useEffect(()=>{
    setTempSelected(selected)
    console.log(questions)
  },[selected])



  function toggle(id){

    if(tempSelected.includes(id))
      setTempSelected(tempSelected.filter(x=>x!==id))
    else
      setTempSelected([...tempSelected,id])

  }



  function selectAll(){

    setTempSelected(filtered.map(q=>q.ID))

  }



  function clearAll(){

    setTempSelected([])

  }



  function applySelection(){

    setSelected(tempSelected)
    onClose()

  }



  /* ------------------------
     Dynamic filter values
  ------------------------ */

  const topics = useMemo(()=>{

    const set = new Set()

    questions.forEach(q=>{
      q.relatedTopics?.forEach(t=>set.add(t))
    })

    return [...set]

  },[questions])



  const sections = useMemo(()=>(
    [...new Set(questions.map(q=>q.sectionName).filter(Boolean))]
  ),[questions])



  const difficulties = useMemo(()=>(
    [...new Set(questions.map(q=>q.difficulty).filter(Boolean))]
  ),[questions])

function clearFilters(){

  setSearch("");
  setTopic("");
  setSection("");
  setDifficulty("");

}

  /* ------------------------
     Filtered questions
  ------------------------ */
const filtered = useMemo(()=>{

  const s = search.toLowerCase();

  return questions.filter(q=>{

    const questionMatch =
      q.question?.toLowerCase().includes(s);

    const optionMatch =
      q.options?.some(o =>
        o.toLowerCase().includes(s)
      );

    return (

      (search ? (questionMatch || optionMatch) : true) &&

      (topic
        ? q.relatedTopics?.includes(topic)
        : true) &&

      (section
        ? q.sectionName === section
        : true) &&

      (difficulty
        ? q.difficulty === difficulty
        : true)

    )

  })

},[questions,search,topic,section,difficulty])


  /* ------------------------
     Virtual row
  ------------------------ */

  const Row = ({ index, style }) => {

    const q = filtered[index]
    const isSelected = tempSelected.includes(q.ID)

    return (
<div  style={style}>
      <div
       
        className={`questionRow ${isSelected ? "selected" : ""}`}
        onClick={()=>toggle(q.ID)}
      >
 <label className={"checkbox-outer  "}>
        <input   className="input-textbox"
          type="checkbox"
          checked={isSelected}
          readOnly
          onClick={(e)=>e.stopPropagation()}
        /> <span class={"square"}></span>

                                                                         </label>
        <div className="questionContent">

          <div className="questionTitle">
            {q.question}
          </div>

          <div className="meta">
            {q.sectionName} • {q.difficulty}
          </div>

          <div className="options">

            {q.options?.map((o,i)=>(
              <div key={i}>
                {String.fromCharCode(65+i)}. {o}
              </div>
            ))}

          </div>

        </div>

      </div>
</div>
    )

  }



  return (

    <div className="modalOverlay">

      <div className="modalContainer">

        <div className="modalHeader">

          <h3>Select Questions</h3>

          <button  className="closeBtn" onClick={onClose}>✕</button>

        </div>



        {/* FILTER BAR */}

        <div className="filterBar">

          <input style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"1px solid  rgba(144, 202, 249,1)"
          ,borderRadius:"15px",cursor:"pointer",height:"25px"}}
            placeholder="Search questions..."
            value={search}
            onChange={(e)=>setSearch(e.target.value)}
          />



          <select style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"1px solid  rgba(144, 202, 249,1)"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
            value={topic}
            onChange={(e)=>setTopic(e.target.value)}
          >
            <option value="">Topic</option>

            {topics.map(t=>(
              <option key={t}>{t}</option>
            ))}

          </select>



          {/* <select
            value={section}
            onChange={(e)=>setSection(e.target.value)}
          >
            <option value="">Section</option>

            {sections.map(s=>(
              <option key={s}>{s}</option>
            ))}

          </select> */}



          <select style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"1px solid  rgba(144, 202, 249,1)"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
            value={difficulty}
            onChange={(e)=>setDifficulty(e.target.value)}
          >
            <option value="">Difficulty</option>

            {difficulties.map(d=>(
              <option key={d}>{d}</option>
            ))}

          </select>



          <button style={{fontSize:"17px",border:"1px solid  rgba(144, 202, 249,1)",background:"rgba(144, 202, 249,1)"
          ,borderRadius:"5px",height:"35px"}} onClick={selectAll}>
            Select All
          </button>

          <button  style={{fontSize:"15px",color:"#ffffff",background:"rgb(235, 121, 121)"
          ,borderRadius:"5px",cursor:"pointer",height:"35px"}} className="clearBtn" onClick={clearAll}>
            Clear
          </button>


<button  style={{fontSize:"15px",color:"#ffffff",background:"rgb(235, 121, 121)"
          ,borderRadius:"5px",cursor:"pointer",height:"35px"}}
  className="clearFilterBtn"
  onClick={clearFilters}
>
Clear Filters
</button>
          <span className="selectedCount">
            {tempSelected.length} Selected
          </span>
  {/* FOOTER */}

        <div className="footerQP">

          <button style={{fontSize:"17px",border:"1px solid  rgba(144, 202, 249,1)",background:"rgba(144, 202, 249,1)"
          ,borderRadius:"5px",height:"35px"}}
            className="applyBtn"
            onClick={applySelection}
          >
            Add Selected Questions
          </button>

        </div>
        </div>



        {/* LIST */}

        <List
          height={600}
          itemCount={filtered.length}
          itemSize={120}
          width={"100%"}
        >
          {Row}
        </List>



      

      </div>



<style>{`

.closeBtn{
  border:none;
  background:#f5f5f5;
  width:32px;
  height:32px;
  border-radius:6px;
  cursor:pointer;
}

.closeBtn:hover{
  background:#eaeaea;
}
.modalOverlay{
position:fixed;
inset:0;z-index:9999999 !important;
background:rgba(0,0,0,0.05);
display:flex;
align-items:center;
justify-content:center;
}

.modalContainer{ 
position:fixed;top:50px;bottom:0px;width:80%;
background:white;
border-radius:10px;
padding:20px;
box-shadow:0 10px 30px rgba(0,0,0,0.2);
}

.modalHeader{
display:flex;
justify-content:space-between;
margin-bottom:10px;
}

.filterBar{
display:flex;
gap:10px;
align-items:center;
margin-bottom:10px;
flex-wrap:wrap;
}

.filterBar input,
.filterBar select{
padding:6px 10px;
border:1px solid #ddd;
border-radius:6px;
}

.filterBar button{
background:#2563eb;
border:none;
color:white;
padding:6px 12px;
border-radius:6px;
cursor:pointer;
}

.clearBtn{
background:#ef4444;
}

.selectedCount{
margin-left:auto;
font-size:13px;
color:#666;
}

.questionRow{
display:flex;
gap:10px;
padding:10px;
border-bottom:1px solid #eee;
cursor:pointer;
}

.questionRow:hover{
background:#f8fafc;
}

.selected{
background:#eef2ff;
}

.questionTitle{
font-weight:600;
margin-bottom:3px;
}

.meta{
font-size:12px;
color:#777;
margin-bottom:5px;
}

.options{
font-size:14px;
color:#444;
}

.footerQP{
margin-top:10px;
display:flex;
justify-content:flex-end;
}

.applyBtn{
background:#16a34a;
color:white;
border:none;
padding:8px 16px;
border-radius:6px;
cursor:pointer;
}
.clearFilterBtn{
background:#64748b;
color:white;
border:none;
padding:6px 12px;
border-radius:6px;
cursor:pointer;
}

`}</style>

    </div>

  )

}